import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Api } from '@core/api/Api';

@Injectable({
  providedIn: 'root',
})
export class SiblingsService {
  private readonly http = inject(HttpClient);

  createPreview(documentsToDismiss: any[], documentsToMerge: any[]) {
    return this.http.post(Api.Siblings.mergePreview, {
      documentsToDismiss,
      documentsToMerge,
    });
  }

  merge(documentsToDismiss: any[], documentsToMerge: any[]) {
    return this.http.post(Api.Siblings.merge, {
      documentsToDismiss,
      documentsToMerge,
    });
  }
}
